import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadMeldungHinweisListStatus: 'idle',
    loadMeldungHinweisListError: undefined as any,
    loadMeldungHinweisListLastArgs: undefined as any,
    loadMeldungHinweisStatus: 'idle',
    loadMeldungHinweisError: undefined as any,
    saveMeldungHinweisStatus: 'idle',
    saveMeldungHinweisError: undefined as any,
    deleteMeldungHinweisStatus: 'idle',
    deleteMeldungHinweisError: undefined as any,

    meldungHinweisList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadMeldungHinweisList = createAsyncThunk('meldungHinweisSlice/loadMeldungHinweisList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().meldungHinweisSlice.loadMeldungHinweisListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldhinweis/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungHinweisListStatus } = getState().meldungHinweisSlice
        return loadMeldungHinweisListStatus !== 'pending'
    }
})

export const loadMeldungHinweis = createAsyncThunk('meldungHinweisSlice/loadMeldungHinweis', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldhinweis/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungHinweisStatus } = getState().meldungHinweisSlice
        return loadMeldungHinweisStatus !== 'pending'
    }
})

export const saveMeldungHinweis = createAsyncThunk('meldungHinweisSlice/saveMeldungHinweis', async ({ meldungHinweis }: any, { rejectWithValue }: any) => {
    let promises = []
    if (meldungHinweis?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurismeldhinweis/${ meldungHinweis?.HDR_ID }/`,
            prepareData(meldungHinweis),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurismeldhinweis/`,
            prepareData(meldungHinweis),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMeldungHinweisStatus } = getState().meldungHinweisSlice
        return saveMeldungHinweisStatus !== 'pending'
    }
})

export const deleteMeldungHinweis = createAsyncThunk('meldungHinweisSlice/deleteMeldungHinweis', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurismeldhinweis/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMeldungHinweisStatus } = getState().meldungHinweisSlice
        return deleteMeldungHinweisStatus !== 'pending'
    }
})

const MeldungHinweisSlice = createSlice({
    name: 'meldungHinweisSlice',
    initialState,
    reducers: {
        resetloadMeldungHinweisListError: (state) => {
            state.loadMeldungHinweisListError = undefined
        },
        resetloadMeldungHinweis: (state) => {
            state.formItem = undefined
            state.loadMeldungHinweisError = undefined
        },
        resetloadMeldungHinweisError: (state) => {
            state.loadMeldungHinweisError = undefined
        },
        resetsaveMeldungHinweis: (state) => {
            state.formItem = undefined
            state.saveMeldungHinweisError = undefined
        },
        resetsaveMeldungHinweisError: (state) => {
            state.saveMeldungHinweisError = undefined
        },
        resetdeleteMeldungHinweisError: (state) => {
            state.deleteMeldungHinweisError = undefined
        },
        removeFromMeldungHinweisListById: (state, action) => {
            state.meldungHinweisList = state.meldungHinweisList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromMeldungHinweisListByIds: (state, action) => {
            state.meldungHinweisList = state.meldungHinweisList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.meldungHinweisList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadMeldungHinweisListStatus = 'preloaded'
            state.loadMeldungHinweisListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.meldungHinweisList = []
            state.loadMeldungHinweisListStatus = 'idle'
            state.loadMeldungHinweisListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMeldungHinweisList.pending, (state) => {
            state.loadMeldungHinweisListStatus = 'pending'
            state.loadMeldungHinweisListError = undefined
        })
        builder.addCase(loadMeldungHinweisList.fulfilled, (state, action) => {
            state.loadMeldungHinweisListStatus = 'idle'

            if (!action.payload) { return }

            state.loadMeldungHinweisListLastArgs = action.payload.args

            {
                state.meldungHinweisList = action.payload.data

            }
        })
        builder.addCase(loadMeldungHinweisList.rejected, (state, action) => {
            state.loadMeldungHinweisListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungHinweisListError = action.error.message
            } else {
                state.loadMeldungHinweisListError = action.payload
            }
        })

        builder.addCase(loadMeldungHinweis.pending, (state) => {
            state.loadMeldungHinweisStatus = 'pending'
            state.loadMeldungHinweisError = undefined
        })
        builder.addCase(loadMeldungHinweis.fulfilled, (state, action) => {
            state.loadMeldungHinweisStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungHinweisList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungHinweisList.push(newItem) }
                else { state.meldungHinweisList[i] = { ...state.meldungHinweisList[i], ...newItem } }
            }
        })
        builder.addCase(loadMeldungHinweis.rejected, (state, action) => {
            state.loadMeldungHinweisStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungHinweisError = action.error.message
            } else {
                state.loadMeldungHinweisError = action.payload
            }
        })

        builder.addCase(saveMeldungHinweis.pending, (state) => {
            state.saveMeldungHinweisStatus = 'pending'
            state.saveMeldungHinweisError = undefined
        })
        builder.addCase(saveMeldungHinweis.fulfilled, (state, action) => {
            state.saveMeldungHinweisStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungHinweisList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungHinweisList.push(newItem) }
                else { state.meldungHinweisList[i] = { ...state.meldungHinweisList[i], ...newItem } }
            }
        })
        builder.addCase(saveMeldungHinweis.rejected, (state, action) => {
            state.saveMeldungHinweisStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMeldungHinweisError = action.error.message
            } else {
                state.saveMeldungHinweisError = action.payload
            }
        })

        builder.addCase(deleteMeldungHinweis.pending, (state) => {
            state.deleteMeldungHinweisStatus = 'pending'
            state.deleteMeldungHinweisError = undefined
        })
        builder.addCase(deleteMeldungHinweis.fulfilled, (state, action) => {
            state.deleteMeldungHinweisStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.meldungHinweisList = state.meldungHinweisList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.meldungHinweisList = state.meldungHinweisList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMeldungHinweis.rejected, (state, action) => {
            state.deleteMeldungHinweisStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMeldungHinweisError = action.error.message
            } else {
                state.deleteMeldungHinweisError = action.payload
            }
        })

    }
})

export const {
    resetloadMeldungHinweisListError,
    resetloadMeldungHinweis,
    resetloadMeldungHinweisError,
    resetsaveMeldungHinweis,
    resetsaveMeldungHinweisError,
    resetdeleteMeldungHinweisError,
    removeFromMeldungHinweisListById,
    removeFromMeldungHinweisListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = MeldungHinweisSlice.actions
export default MeldungHinweisSlice.reducer
